<ng-container>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button class="cancel-btn" fill="solid" (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="title">{{ 'Seats.SeatLocation' | translate }}</ion-title>
  </ion-toolbar>
  <ion-content class="bg-lightgrey">
    <form [formGroup]="form" class="seats-form">
      <div style="display: flex; justify-content: space-evenly;">
        <ion-item color="dark" class="input-field">
          <ion-label position="floating">{{'Seats.Section' | translate}}</ion-label>
          <ion-input formControlName="section"  type="text"></ion-input>
        </ion-item>

        <ion-item color="dark" class="input-field">
          <ion-label position="floating">{{'Seats.Row' | translate}}</ion-label>
          <ion-input formControlName="row" type="text"></ion-input>
        </ion-item>

        <ion-item color="dark" class="input-field">
          <ion-label position="floating">{{'Seats.SeatNumber' | translate}}</ion-label>
          <ion-input formControlName="seatNumber" type="text"></ion-input>
        </ion-item>
      </div>
      <ion-button (click)="onEnter()" class="ion-margin-top next-btn" expand="block" >
        {{'General.Next' | translate}}
      </ion-button>
    </form>
    @if (showInner && seatInfo) {
      <div class="inner-popup">
        <p>{{'Seats.Section' | translate}}: {{seatInfo.section}}</p>
        <p>{{'Seats.Row' | translate}}: {{seatInfo.row}}</p>
        <p>{{'Seats.SeatNumber' | translate}}: {{seatInfo.seatNumber}}</p>
        <ion-button (click)="onSubmit()" class="ion-margin-top next-btn" expand="block" >
          {{'General.Confirm' | translate}}
        </ion-button>
        <ion-button (click)="showInner = false" class="ion-margin-top next-btn" expand="block" >
          {{'General.Close' | translate}}
        </ion-button>
      </div>
    }
  </ion-content>
</ng-container>